/**
 * Root Canal Treatment — tapered gutta-percha filling every canal, an access
 * cavity on the crown, and a small radiopaque post at the coronal end.
 * Canal count auto-adapts to tooth type (molar=3, premolar=2, else=1).
 */
import { rootCanals, uid } from "./_shared";

export default function RCT({ type = "incisor", toothId }) {
  const canals = rootCanals(type);
  const gid = uid("rct", toothId);

  return (
    <g style={{ pointerEvents: "none" }}>
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"   stopColor="#B54A2C" />
          <stop offset="55%"  stopColor="#8A2E18" />
          <stop offset="100%" stopColor="#4A1608" />
        </linearGradient>
      </defs>

      {canals.map((c, i) => (
        <g key={i}>
          {/* Gutta-percha inside canal — tapered from top to apex */}
          <path
            d={`M ${c.x - 1.6} 90
                L ${c.x + 1.6} 90
                L ${c.tip[0] + 0.8} ${c.tip[1] - 2}
                L ${c.tip[0] - 0.8} ${c.tip[1] - 2} Z`}
            fill={`url(#${gid})`}
            stroke="#3A1004"
            strokeWidth={0.35}
          />
          {/* Coronal extension into pulp chamber */}
          <rect x={c.x - 1.4} y={62} width={2.8} height={30}
                fill={`url(#${gid})`} />
        </g>
      ))}

      {/* Pulp chamber floor — dark radiopaque body */}
      <path d="M 16 60 Q 30 55 44 60 L 44 66 Q 30 63 16 66 Z"
            fill="#5C1E10" stroke="#2A0A05" strokeWidth={0.4} />

      {/* Access cavity opening — small dark oval on occlusal */}
      <ellipse cx={30} cy={54} rx={4.5} ry={2.2} fill="#1C0803" />
      <ellipse cx={30} cy={54} rx={3.2} ry={1.4} fill="#4A1608" />

      {/* Metallic radiopaque post (subtle silver line) */}
      <rect x={29.2} y={48} width={1.6} height={16}
            fill="#C9CDD3" opacity={0.75} />
      <rect x={29.6} y={48} width={0.5} height={16}
            fill="#F1F3F6" opacity={0.9} />
    </g>
  );
}
